// =============================================================================
// Hero slider — Swiper with fade, autoplay, keyboard nav.
// Autoplay pauses while the tab is hidden.
// =============================================================================
(function ($) {
    'use strict';

    $(function () {
        if (typeof Swiper === 'undefined') { return; }

        const $container = $('[data-hero-swiper]');
        if (!$container.length) { return; }

        const swiper = new Swiper($container[0], {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            speed: 900,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            keyboard: { enabled: true, onlyInViewport: true },
            a11y: {
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
            },
            navigation: {
                prevEl: '.hero-swiper__nav--prev',
                nextEl: '.hero-swiper__nav--next',
            },
        });

        document.addEventListener('visibilitychange', () => {
            if (!swiper || !swiper.autoplay) { return; }
            if (document.hidden) { swiper.autoplay.stop(); }
            else { swiper.autoplay.start(); }
        });
    });
})(jQuery);
